import * as React from "react";

import {AsyncCreateActivityAssignmentModal} from "@khan/assignments-async-loader";
import {useActivityData} from "@khan/guide-core";

interface Props {
    activityContentDescriptor: string;
    onClose?: () => unknown;
    onSuccess?: () => unknown;
}

const CreateActivityAssignmentLauncher = (
    props: Props,
): React.ReactElement | null => {
    // Hooks
    const {activityContentDescriptor, onClose, onSuccess} = props;
    const [activityKind, activityID] = activityContentDescriptor.split(":");
    const activityDCULData = useActivityData(activityID, activityKind);

    // Only show the Create Assignment button for valid AIGuideActivity content
    // NOTE: We are not checking whether this specific activity is assignable
    // as we are checking that upstream, but if we want to add that check here
    // to be more defensive, we can do so.
    if (
        activityDCULData.status !== "ready" ||
        activityDCULData.contentKind !== "AIGuideActivity" ||
        !activityDCULData.contentId
    ) {
        return null;
    }

    const {domainId, courseId, unitId, lessonId, contentKind, contentId} =
        activityDCULData;

    return (
        <AsyncCreateActivityAssignmentModal
            contentDescriptor={activityContentDescriptor}
            contentPath={{
                domainId,
                courseId,
                unitId,
                lessonId,
                contentKind,
                contentId,
            }}
            onClose={onClose}
            onSuccess={onSuccess}
        />
    );
};

export default CreateActivityAssignmentLauncher;
